"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftRewardPrizeRelationshipToJSON = exports.NftRewardPrizeRelationshipFromJSONTyped = exports.NftRewardPrizeRelationshipFromJSON = void 0;
function NftRewardPrizeRelationshipFromJSON(json) {
    return NftRewardPrizeRelationshipFromJSONTyped(json, false);
}
exports.NftRewardPrizeRelationshipFromJSON = NftRewardPrizeRelationshipFromJSON;
function NftRewardPrizeRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'nftReward': json['nftReward'],
        'nftRewardPrize': json['nftRewardPrize'],
    };
}
exports.NftRewardPrizeRelationshipFromJSONTyped = NftRewardPrizeRelationshipFromJSONTyped;
function NftRewardPrizeRelationshipToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'nftReward': value.nftReward,
        'nftRewardPrize': value.nftRewardPrize,
    };
}
exports.NftRewardPrizeRelationshipToJSON = NftRewardPrizeRelationshipToJSON;
